import { MarkupElement, MarkupValue } from 'src/api/models/MarkupHtml';

export const cleanNewLines = (contentHtmlAst: (MarkupElement | MarkupValue)[]): (MarkupElement | MarkupValue)[] => {
  const sequenceContentHtmlAst = contentHtmlAst.reduce(
    (acc, curr) => {
      if (curr.type === 'element' && curr.children.length) {
        acc.push({ ...curr, children: cleanNewLines(curr.children) });
      } else {
        acc.push(curr);
      }

      return acc;
    },
    [] as (MarkupElement | MarkupValue)[]
  );

  const noNewLinesContentHtml = sequenceContentHtmlAst
    .filter((c) => !(c.type === 'text' && c.value === '\n'))
    .filter((c) => (c.type === 'element' && !!c.children.length) || (c.type === 'text' && !!c.value));

  return noNewLinesContentHtml;
};
